<template>
    <div class="main-content">
        <div v-if="countries">
            <div class="card">
                <div class="card-body">
                    <form action="" @submit="getRejectedOrders">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label for="">Страна закупки</label>
                                    <select class="form-control" v-model="selectedCountry">
                                        <option v-for="(name, index) in countries" :value="index">{{name}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label for="">Статистика за кол. дней</label>
                                    <input v-model="days" type="number" required class="form-control">
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label for="">Сортировка</label>
                                    <select @change="sortedDrugs(sorting)" class="form-control" v-model="sorting">
                                        <option value="name">По алфавиту</option>
                                        <option value="fresh_order_time">По дате заявок</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="">Слова, которые встречаются в причине отказа (через запятую)</label>
                                    <input v-model="words" type="text" required class="form-control">
                                    <p><small>Учитывается регистр текста, если хотите указать слово "склад", то добавьте и "Склад"</small></p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 text-right">
                                <vue-ladda @click="getRejectedOrders" button-class="btn btn-info"
                                           data-style="zoom-in"
                                           :loading="btnLoading">Показать
                                </vue-ladda>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <div class="text-center">
                        <pulse-loader :loading="loading" :color="color"/>
                    </div>
                    <div v-if="!loading">
                        <table class="table table-hover table-striped">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Препарат</th>
                                    <th>Заявки</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(drug, index) in drugs">
                                    <td>{{index+1}}</td>
                                    <td>{{drug.name}} ({{drug.id}})</td>
                                    <td>
                                        <p v-for="order in drug.orders"><strong>{{order.id}} ({{order.qty}})</strong>: <small class="text-muted">{{order.created}}</small> <span v-html="order.text"></span></p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>


    import api from '@/api'
    import VueLadda from 'vue-ladda/src/vue-ladda.vue'
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

    export default {
        components: {
            VueLadda,
            PulseLoader,
        },
        data() {
            return {
                loading: true,
                color: '#5BBFDE',
                countries: null,
                selectedCountry: null,
                days: 15,
                words: 'наличи, тсутст, клад',
                btnLoading: false,
                drugs: null,
                sorting: 'name',
            }
        },
        mounted() {
            this.getCities();
            // this.getRejectedOrders();
        },
        methods: {
            sortedDrugs(field = null) {
                this.drugs = _.orderBy(this.drugs, field, field === 'name' ? 'asc' : 'desc');
            },
            async getRejectedOrders(e) {
                e.preventDefault();
                this.loading = true;
                this.btnLoading = true;
                this.drugs = null;
                let {data} = await api.post('/orders/getRejectedOrders', {
                    countryId: this.selectedCountry,
                    days: this.days,
                    words: this.words,
                });
                this.drugs = data.drugs;
                this.sortedDrugs(this.sorting);
                this.loading = false;
                this.btnLoading = false;
            },
            async getCities() {
                let {data} = await api.index('/getCountries');
                this.countries = data.countries;
                this.selectedCountry = Object.keys(this.countries)[0];
                this.loading = false;
            },
        }
    }

</script>

<style scoped>
    .table p{
        margin-bottom: 3px;
    }
</style>
